import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-inbox",
  templateUrl: "./med-icon-inbox.component.html",
})
export class MedIconInboxComponent extends SvgMixinComponent {}
